import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/content';
export function Hero() {
  return <header className="px-5 pb-8 pt-8" data-id="element-141" data-mp="ei1unjxvvyww">
      <h1 className="text-center font-display text-[30px] leading-[1.1] tracking-tight text-[#16302a] sm:text-4xl" data-id="element-142" data-mp="9k0h1ej88rst">
        Deja de improvisar tus clases de gimnasia postural
      </h1>

      <a href="#compra" className="mt-6 block" aria-label="Ir a la sección de compra" data-id="element-143" data-mp="12a0kd8y2xwtk">
        <img src={PRODUCT_IMAGE} alt="Gimnasia Postural Resuelta: pack completo de tomos, fichas y bonos en PDF" className="mx-auto w-full max-w-md drop-shadow-xl" data-id="element-144" data-mp="xanpq20yvlgf" />
      </a>

      <p className="mt-6 text-center text-[15px] leading-relaxed text-[#3d4f47]" data-id="element-145" data-mp="ncq4lneem4s1">
        Todo lo que necesitas para planificar clases de gimnasia postural más estructuradas, seguras y
        profesionales, sin perder horas preparando cada sesión.
      </p>

      <ul className="mt-5 flex flex-wrap items-center justify-center gap-2 text-[12px] font-semibold text-[#3f5d4e]" data-id="element-146" data-mp="384s6grzq2r4n">
        {['📄 100% PDF', '⚡️ Entrega Inmediata', 'Pago único'].map(tag => <li key={tag} className="rounded-full border border-[#c9d6cd] bg-white/70 px-3 py-1.5 backdrop-blur-sm" data-id="element-147" data-mp="3o59d9ms2zcg4">
            {tag}
          </li>)}
      </ul>

      <div className="mt-6" data-id="element-148" data-mp="3eb92b4a4bczh">
        <CTAButton data-id="element-149" data-mp="30hhohjpct6xy" />
      </div>

      <div className="mt-4 flex items-center justify-center gap-2" data-id="element-150" data-mp="30ggdff8c8kg8">
        <div className="flex" aria-hidden="true" data-id="element-151" data-mp="358zqmb345dki">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-[#e0a11a] text-[#e0a11a]" data-id="element-152" data-mp="2qkdba9dhklta" />)}
        </div>
        <span className="text-[13px] font-bold text-[#16302a]" data-id="element-153" data-mp="2vi54d6pvadz2">4.9/5</span>
        <span className="text-[12px] text-[#5f6f68]" data-id="element-154" data-mp="2hj5i25ptub62">· valorado por profesionales</span>
      </div>
    </header>;
}